import { getSrc } from "gatsby-plugin-image";

const getImageSrc = (data, fallback = null) => {
  return data && data.gatsbyImageData ? getSrc(data.gatsbyImageData) : fallback;
};

export default getImageSrc;
